export default {
	data() {
		return {
			loadingRoles: true,
			roles: {}
		}
	},

	mounted() {
		this.loadingRoles = true;
		$.ajax({
			url: route('api.v1.roles.index'),
			success: (response) => {
				this.roles = response.data;
			}
		});
		this.loadingRoles = false
	}
}